module.exports = __webpack_public_path__ + "static/media/show-idle.a33c4a9d.svg";